import constraintStyles from "../../styles/constraint.module.css";

const ConstraintBlock = ({ children }: { children: React.ReactNode }) => {
  return <div className={constraintStyles.block}>{children}</div>;
};

export default ConstraintBlock;
